module.exports = __webpack_public_path__ + "5a73e093b4b85e10ebd097343a89e3fc.pdf";